import { Analytics } from './analytics';

let teaserListItem = $('[teaser-list-item-tracking]');
let teaserSectionLink = $('[teaser-section-link]'); 

teaserListItem.click((e) => {
    let url = $(e.currentTarget).find('[teaser-list-item-url-tracking]').attr('href');
    let itemTitle = $(e.currentTarget).find('[teaser-list-item-title-tracking]').text();
    let position = $(e.currentTarget).find('[teaser-list-item-url-tracking]').attr('teaser-list-item-position-tracking');
    let sectionTitle = $(e.target).closest('[teaser-list-item-container-tracking]').siblings('[teaser-list-section-title-tracking]').text();
    
    Analytics.sendEvent("Homepage - " + sectionTitle, itemTitle + ' | ' + position, url)
});

teaserSectionLink.click((e) => {
    let url = $(e.currentTarget).attr('href');
    let linkLabel = $(e.currentTarget).text();
    let sectionTitle = $(e.target).closest('[teaser-section-link-container]').siblings('[teaser-list-section-title-tracking]').text();
    
    Analytics.sendEvent(`Homepage - ${linkLabel}` + " button", sectionTitle, url)
});